// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__bIlBy","paymentContainer":"PaymentPage_paymentContainer__1odPJ"};